import useDeviceType from "../common/useDeviceType";

const Event = () => {
  const isMobile = useDeviceType();
  return (
    <div
      id="event"
      className="relative w-full h-full lg:px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center"
    >
      <p className="text-xl 2xl:text-2xl text-secondary">
        누수, 어렵고&nbsp;막막하게만&nbsp;느껴지시나요?
      </p>
      <h2 className="font-light text-3xl lg:text-4xl 2xl:text-5xl leading-tight text-primary">
        누수, 어떤것부터&nbsp;알아봐야&nbsp;할까?
      </h2>
      <div className="relative w-full h-full max-w-screen-xl mx-auto mt-12">
        <div data-aos="fade-up">
          <img src="/images/event1.png" alt="장인누수 견적안내" />
        </div>
        <div data-aos="fade-up" data-aos-delay="50" className="lg:-mt-28">
          <img
            src={isMobile ? "/images/event2Mo.png" : "/images/event2.png"}
            alt="장인누수 견적안내"
            className="!relative w-auto h-full max-h-[160px] mx-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default Event;
